import K from '../constants';
import restHelpers from '../helpers/restHelper';
import getMockresponse from './__mocks/carList/getWithRpm';

const getMockresponseFnIgnored = () => Promise.resolve(getMockresponse);

const get = () => restHelpers.withBearer.get(`${K.API_URL}/cars?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}`, {});

const getPlates = () => restHelpers.withBearer.get(`${K.API_URL}/cars/get-plates?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}`, {});

const getMinimal = (filters, size = 3, page = 1) => restHelpers.withBearer.post(`${K.API_URL}/cars/get-minimal?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}&size=${size}&page=${page}`, { data: filters });

const getFilters = (filters) => restHelpers.withBearer.post(`${K.API_URL}/cars/get-filters?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}`, { data: filters });

const getDashboardCarsList = (filters, size = 3, page = 1) => restHelpers.withBearer.post(`${K.API_URL}/cars/get-dashboard-cars-list?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}&size=${size}&page=${page}`, { data: filters });

const getDashboardCarsFilters = (filters) => restHelpers.withBearer.post(`${K.API_URL}/cars/get-dashboard-cars-filters?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}`, { data: filters });

const getDashboardCarsOnMap = (filters) => restHelpers.withBearer.post(`${K.API_URL}/cars/get-dashboard-cars-on-map?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}`, { data: filters });

const getDashboard = (filters, size = 3, page = 1) => restHelpers.withBearer.post(`${K.API_URL}/cars/get-dashboard?_=${Math.round(new Date().getTime() / (1000 * 10 * 60))}&size=${size}&page=${page}`, { data: filters });

const updateCarFn = (plate, data) => restHelpers.withBearer.put(`${K.API_URL}/cars/by-plate/${plate}`, { data: data });

export default {
  _get: getMockresponseFnIgnored,
  get: get,
  getPlates: getPlates,
  getMinimal: getMinimal,
  getFilters: getFilters,
  getDashboardCarsList: getDashboardCarsList,
  getDashboardCarsFilters: getDashboardCarsFilters,
  getDashboardCarsOnMap: getDashboardCarsOnMap,
  getDashboard: getDashboard,
  updateCar: updateCarFn,
};



// WEBPACK FOOTER //
// ./src/services/carList.js